
import { Component, Vue } from 'vue-property-decorator'
import { MediaService } from '@/services/index'
import { isValidURL } from '@/common/utils'
import { Form as ElForm } from 'element-ui'

@Component({
    name: 'MediaOrgEdit',
    components: {
    }
})
export default class extends Vue {

    private validateURL = (rule: any, value: string, callback: Function) => {
        if (!isValidURL(value)) {
            callback(new Error('请输入正确的URL'))
        } else {
            callback()
        }
    }

    private orgRules = {
        name: [
            { required: true, message: '请输入集团名称', trigger: 'blur' },
            { min: 2, max: 20, message: '集团名称长度为2~20位', trigger: 'blur' }
        ]
    }

    private orgForm: any = {}
    private orgName: string = ''
    private isUpdateLoading: boolean = false
    private isDeleteLoading: boolean = false
    private isSearching: boolean = false
    private orgId = ''
    private medias: string[] = []
    private mediaOptions: number[] = []

    private mounted() {
        this.orgId = this.$route.params.id
        this.fetchOrgDetail(parseInt(this.orgId))
    }

    private async fetchOrgDetail(orgId: number) {
        const result = await MediaService.getOrgDetail({ id: orgId })
        if (result.status === 200) {
            this.orgForm = result.data
            this.medias = Object.assign(this.orgForm.medias)
            this.orgForm.medias = this.getMediaName(this.orgForm.medias)
            this.orgName = this.orgForm.name
        }
    }

    private async fetchMedia(query: any) {
        if (query !== '') {
            this.isSearching = true
            const result = await MediaService.searchMedia({ value: query })
            if (result.status === 200) {
                this.mediaOptions = result.data
            }
            this.isSearching = false
        } else {
            this.mediaOptions = []
        }
    }

    private getMediaName(medias: any) {
        if (medias.length === 0) return []
        const result = medias.map((media: any) => { return media.name })
        return result
    }
// 修复 getIptMedias 方法，添加防御性检查
    private getIptMedias() {
        let result: number[] = []
        const medias = this.orgForm.medias || []  // ← 添加默认值
        medias.map((value: any) => {
            if (typeof value === 'object') {
                result.push(value.id)
            } else {
                this.medias.forEach((media: any) => {
                    if (media.name === value) { result.push(media.id) }
                })
            }
        })
        return result
    }

    private onSelectChange() {
        (this.$refs.orgForm as ElForm).validateField('medias')
    }

    private onUpdate() {
        this.isUpdateLoading = true
        const formRef=this.$refs.orgForm as ElForm
        formRef.validate(async(valid: boolean) => {
            if (valid) {
                try {
                    const params = {
                        id: this.orgForm.id,
                        name: this.orgForm.name,
                        url: this.orgForm.url,
                        intro: this.orgForm.intro,
                        medias: this.getIptMedias()
                    }
                    const result = await MediaService.updateOrg(params)
                    if (result.status === 200) {
                        this.$message({ type: 'success', message: '更新成功' })
                    } else {
                        this.$message({ type: 'error', message: '更新集团失败' })
                    }

                }catch (error){
                    this.$message({ type: 'error', message: '提交失败' +error.message})
                }finally {
                    this.isUpdateLoading = false//确保loading状态被重置
                }
            } else {
                this.isUpdateLoading = false//验证失败时也要重置loading
                return false
            }
        })
    }

    private onRemove() {
        this.$confirm('确认删除此集团?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            this.isDeleteLoading = true
            const result = await MediaService.removeOrg({ id: parseInt(this.orgId) })
            if (result.status === 200) {
                this.$message({ type: 'success', message: '删除成功' })
            } else {
                this.$message({ type: 'error', message: '删除集团失败' })
            }
            this.isDeleteLoading = false
        }).catch(() => {
            this.$message({ type: 'info', message: '已取消操作' })         
        })
    }
}
